import React from 'react';

import type { Account } from '../../../generated-types';
import useTranslation from '../../../hooks/useTranslation';
import { BsuDetails } from '../AccountViewTypes';
import AccountBalanceView from './AccountBalanceView';

type Props = {
    account?: Account;
    bsuDetails?: BsuDetails;
    ageOver34?: boolean;
};
const AccountBalanceWrapper: React.FC<Props> = ({ account, bsuDetails, ageOver34 = false }) => {
    const translated = useTranslation();
    if (!account) return null;
    const hasDifferentCurrency = account.localBalance?.currency && account.localBalance?.currency !== account.currency;
    return (
        <>
            <dt className="screen-reader-text">{translated.accountView.disposible}</dt>
            <dd
                className="account-details__amount"
                itemProp="amount"
                itemScope
                itemType="https://schema.org/MonetaryAmount"
            >
                <AccountBalanceView
                    balance={account.balance}
                    currency={account.currency}
                    accountType={account.type}
                    bsuDetails={bsuDetails}
                    ageOver34={ageOver34}
                />
                <meta itemProp="currency" content={account.currency.toString()} />
            </dd>
            {hasDifferentCurrency && (
                <dd
                    className="account-view__local-currency"
                    itemProp="amount"
                    itemScope
                    itemType="https://schema.org/MonetaryAmount"
                >
                    <AccountBalanceView
                        balance={account.localBalance!}
                        currency={account.localBalance!.currency}
                        accountType={account.type}
                    />
                    <meta itemProp="currency" content={account.localBalance?.currency.toString()} />
                </dd>
            )}
        </>
    );
};

export default AccountBalanceWrapper;
